var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors && _vm.errors.length > 0)?_c('div',{staticClass:"tw-mt-2 tw-text-sm tw-text-error md:tw-text-base"},_vm._l((_vm.errors),function(error){return _c('div',{key:error},[_vm._v(" "+_vm._s(error)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }